(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ora-abalone-race"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('ora-abalone-race')) return;
  class OraAbaloneRace extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => { if (this.isConnected && !this.cleanup) this.cleanup = mount(this); });
    }
    disconnectedCallback() { if (this.cleanup) this.cleanup(); this.cleanup = null; }
  }
  function mount(root) {
    const $ = key => root.querySelector(`[data-race="${key}"]`);
    const strings = JSON.parse($('translations').textContent);
    const t = (key, values = {}) => (strings[key] || key).replace(/\{(\w+)\}/g, (_, k) => values[k] ?? '');
    const esc = value => String(value).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
    const names = Array.from({length:5}, (_, i) => t('racer_' + (i + 1)));
    const track = $('track'), cards = $('racers'), runners = [], buttons = [];
    const sprites = Array.from({length:5}, (_, i) => esc(root.getAttribute('data-sprite-' + (i+1))));
    const colours = ['#CE651C','#147FA5','#E3B42A','#DE554E','#7445A0'];
    const inks = ['#192E29','#FFFFFF','#192E29','#192E29','#FFFFFF'];
    const lifecycle = new AbortController();
    let selected = 0, phase = 'ready', elapsed = 0, last = 0, paused = false, frame = 0, cheers = 0, lastCheer = -10, nextComment = 6, plans = [], order = [], countElapsed = 0;
    cards.replaceChildren(); track.querySelectorAll('.lane').forEach(el => el.remove());
    for (let i = 0; i < 5; i++) {
      const lane = document.createElement('div'); lane.className = 'lane'; lane.style.setProperty('--racer-colour', colours[i]); lane.style.setProperty('--racer-ink', inks[i]);
      lane.innerHTML = `<span class="lane-number">${i+1}</span><div class="runner"><img src="${sprites[i]}" width="76" height="48" alt="${esc(names[i])}"></div>`;
      track.appendChild(lane); runners.push(lane.querySelector('.runner'));
      const b = document.createElement('button'); b.type = 'button'; b.className = 'card'; b.style.setProperty('--racer-colour', colours[i]); b.style.setProperty('--racer-ink', inks[i]);
      b.innerHTML = `<span class="num">0${i+1}</span><img src="${sprites[i]}" width="95" height="56" alt=""><strong>${esc(names[i])}</strong><small>${esc(t('bio_'+(i+1)))}</small>`;
      b.onclick = () => select(i); cards.appendChild(b); buttons.push(b);
    }
    function select(i) {
      if (phase !== 'ready') return;
      selected = i; root.style.setProperty('--selected-colour', colours[i]); root.style.setProperty('--selected-ink', inks[i]);
      buttons.forEach((b,n) => b.setAttribute('aria-pressed', String(n === i)));
      runners.forEach((r,n) => { r.classList.toggle('selected', n === i); r.dataset.pick = t('your_pick'); });
      $('cheer').textContent = t('cheer', {name:names[i]});
    }
    function say(text) { $('comment').textContent = '“' + text + '”'; }
    function plan() {
      const finish = 60 + Math.random() * 8;
      const weights = Array.from({length:16}, () => Math.random() < .19 ? .04 : .4 + Math.random() * 1.5);
      const sum = weights.reduce((a,b) => a+b, 0), cumulative = [0];
      weights.forEach(v => cumulative.push(cumulative.at(-1) + v/sum));
      return {finish, cumulative};
    }
    function progress(p, seconds) {
      const x = Math.min(1, seconds/p.finish) * 16, seg = Math.min(15, Math.floor(x)), f = x-seg;
      return Math.min(1, p.cumulative[seg] + (p.cumulative[seg+1]-p.cumulative[seg])*f);
    }
    function start() {
      if (phase !== 'ready') return;
      phase = 'countdown'; paused = false; elapsed = 0; countElapsed = 0; last = 0; cheers = 0; lastCheer = -10; nextComment = 6;
      plans = names.map(plan); order = plans.map((p,i) => ({i,time:p.finish})).sort((a,b) => a.time-b.time);
      buttons.forEach(b => b.disabled = true); $('start').hidden = true; $('countdown').hidden = false;
      $('countdown').textContent = '3'; $('status').textContent = t('count_status'); say(t('count_comment'));
      frame = requestAnimationFrame(tick);
    }
    function tick(now) {
      const dt = last ? Math.min((now-last)/1000, .1) : 0; last = now;
      if (!paused) {
        if (phase === 'countdown') {
          countElapsed += dt; $('countdown').textContent = countElapsed < 3 ? String(3-Math.floor(countElapsed)) : t('go');
          if (countElapsed >= 3.8) {
            phase = 'racing'; $('countdown').hidden = true; $('pause').hidden = false; $('cheer').hidden = false;
            $('status').textContent = t('running'); $('action-note').textContent = t('cheer_note');
            $('pick-heading').textContent = t('backing',{name:names[selected]}); $('pick-hint').textContent = t('pick_hint'); say(t('off'));
          }
        } else if (phase === 'racing') {
          elapsed += dt; render();
          if (elapsed >= nextComment) { commentary(); nextComment += 5 + Math.random()*3; }
          if (elapsed >= order[4].time+.3) { finish(); return; }
        }
      }
      frame = requestAnimationFrame(tick);
    }
    function render() {
      if (!plans.length) return;
      const travel = Math.max(0, track.clientWidth-runners[0].offsetWidth*.94);
      runners.forEach((r,i) => r.style.left = progress(plans[i],elapsed)*travel + 'px');
      $('timer').textContent = '00:' + Math.min(elapsed,order[4].time).toFixed(1).padStart(4,'0');
      $('cheer').disabled = paused || elapsed-lastCheer < 1.3;
    }
    function commentary() {
      const leader = plans.map((p,i) => ({i,x:progress(p,elapsed)})).sort((a,b) => b.x-a.x)[0].i;
      if (elapsed > 33) say(t('finish_comment',{name:names[leader]}));
      else if (Math.random() < .3) say(t('leading',{name:names[leader]}));
      else say(t('line_'+(1+Math.floor(Math.random()*7))));
    }
    function cheer() {
      if (phase !== 'racing' || paused || elapsed-lastCheer < 1.3) return;
      lastCheer = elapsed; cheers++; const r = runners[selected];
      r.classList.remove('wiggle'); void r.offsetWidth; r.classList.add('wiggle');
      say(t('cheer_'+(1+cheers%3),{name:names[selected]})); $('cheer').disabled = true;
    }
    function togglePause() {
      if (phase !== 'racing') return;
      paused = !paused; $('pause').textContent = t(paused?'resume':'pause');
      $('status').textContent = t(paused?'break':'running'); $('cheer').disabled = paused;
    }
    function finish() {
      phase = 'finished'; cancelAnimationFrame(frame);
      const winner = order[0].i, place = order.findIndex(x => x.i === selected)+1;
      $('status').textContent = t('official'); $('pause').hidden = true; $('cheer').hidden = true; $('again').hidden = false;
      $('action-note').textContent = t('fresh');
      $('result').innerHTML = `<span class="eyebrow">${esc(t('photo'))}</span><h2>${esc(t('wins',{name:names[winner]}))}</h2><div class="photo"><img src="${sprites[winner]}" width="60" height="38" alt="${esc(names[winner])}"><span>${esc(t('winning_time'))} <strong>${order[0].time.toFixed(2)}s</strong></span></div><p>${esc(place===1?t('win_message'):t('place_message',{name:names[selected],place}))}</p><ol>${order.map((x,n)=>`<li class="${x.i===selected?'mine':''}"><span>${n+1}. ${esc(names[x.i])}${x.i===selected?' ★':''}</span><span class="finish-time">${x.time.toFixed(2)}s</span></li>`).join('')}</ol><p><em>${esc(t('glory'))}</em></p>`;
      $('result').hidden = false; say(t('winning_comment',{name:names[winner]})); $('again').focus({preventScroll:true});
    }
    function reset(focus = true) {
      cancelAnimationFrame(frame); phase = 'ready'; paused = false; elapsed = 0; plans = []; order = [];
      ['result','again','pause','cheer','countdown'].forEach(k => $(k).hidden = true);
      $('cheer').disabled = false; $('start').hidden = false; $('start').disabled = false; $('pause').textContent = t('pause'); $('timer').textContent = '00:00.0';
      $('status').textContent = t('awaiting'); $('pick-heading').textContent = t('pick'); $('pick-hint').textContent = t('hint'); $('action-note').textContent = t('note');
      buttons.forEach(b => b.disabled = false); runners.forEach(r => {r.style.left='0px';r.classList.remove('wiggle')});
      select(selected); say(t('reset_comment')); if (focus) $('start').focus({preventScroll:true});
    }
    $('start').onclick = start; $('cheer').onclick = cheer; $('pause').onclick = togglePause; $('again').onclick = () => reset();
    reset(false); say(t('initial'));
    const observer = new ResizeObserver(render); observer.observe(track);
    document.addEventListener('visibilitychange', () => {if(document.hidden && phase==='racing' && !paused) togglePause();}, {signal:lifecycle.signal});
    return () => {cancelAnimationFrame(frame);lifecycle.abort();observer.disconnect();};
  }
  customElements.define('ora-abalone-race', OraAbaloneRace);
})();


  } catch(e) { console.error(e); }
})();
})();
